import { getJson, postJson, putJson, deleteJson, withDone, withMap } from '@rad/utility/http';
import { BLOB_BASE } from '../constants';
const mapOne = (document) => (Object.assign(Object.assign({}, document), { 'url': `${BLOB_BASE}/${document.storagePath}` }));
const map = (documents) => documents.map(mapOne);
export const getOwnerVaultDocuments = () => withMap(getJson('/api/owner-vault'), map);
export const createOwnerVaultDocument = (data) => withDone(withMap(postJson('/api/owner-vault', data), mapOne))();
export const updateOwnerVaultDocument = (data) => withDone(withMap(putJson('/api/owner-vault', data), mapOne))();
export const deleteOwnerVaultDocument = (id) => withDone(deleteJson(`/api/owner-vault/${id}`))();
